import { Pipe, PipeTransform } from "@angular/core";
import { EntityDrug } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { ToolsService } from "../providers/tools.service";

@Pipe({ name: "displayQuantity" })
export class DisplayQuantityPipe implements PipeTransform {
  public transform(quantity: string): string {
    return EntityDrug.computeQuantityDisplay(quantity, ToolsService.SUFFIX_QUANTITY);
  }
}

@Pipe({ name: "displayTextForQuantity" })
export class DisplayTextForQuantityPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  public transform(quantity: string): string {
    if (Number.isFinite(Number(quantity))) {
      return this.translateService.instant("drugDetails.plannedQuantity");
    } else {
      return this.translateService.instant("mydrugs.indication");
    }
  }
}
